import * as React from 'react';
import { useEffect, useState } from 'react';
import { TransProps, useTranslation } from 'react-i18next';

import { MenuPositionData } from '../../../interfaces';
import { Overlay } from '../../../theme';
import { UseState } from '../../../types';

import { CloseButton, Container, MenuPositionItem, MenuPositions } from './onTopSimpleMenu.styled';
import { OnTopSimpleMenuProps } from './onTopSimpleMenu.types';

export const OnTopSimpleMenu: React.FC<OnTopSimpleMenuProps> = (props: OnTopSimpleMenuProps): JSX.Element => {
  const { t }: TransProps<never> = useTranslation();
  const { positions, isOpen, onIsOpenUpdate, className }: OnTopSimpleMenuProps = props;
  const [isVisible, setIsVisible]: UseState<boolean> = useState<boolean>(isOpen);

  useEffect((): void => setIsVisible(isOpen), [isOpen]);

  useEffect((): void => onIsOpenUpdate(isVisible), [isVisible]);

  return (
    <> 
      <Container
        className={className}
        onClick={() => setIsVisible(false)}
        $isVisible={isVisible}
      >
        <MenuPositions>
          {positions.map((item: MenuPositionData): JSX.Element => (
            <MenuPositionItem {...item} key={item.label} />
          ))}
        </MenuPositions>
        <CloseButton>{t('onarte.common.cancel')}</CloseButton>
      </Container>
      <Overlay $isVisible={isVisible} onClick={(): void => setIsVisible(false)} />
    </>
  );
};
